import React from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useSelection } from '@providers/SelectionProvider'

const EditButton: React.FC = () => {
  const { t } = useTranslation()
  const { actions, isEditing, isSorting, items } = useSelection()

  // Don't show edit button if there are not items to edit
  if (!items.length) return null

  // Show "Done" button if we are currently editing or sorting
  if (isEditing || isSorting) {
    return (
      <Button
        variant="outline"
        size="sm"
        className="font-medium text-sm"
        onClick={() => {
          if (isSorting) actions.setSorting(false)
          else actions.stopEditing()
        }}>
        {t('action.done')}
      </Button>
    )
  }

  // Otherwise, show the edit list button
  return (
    <Button variant="outline" size="sm" className="font-medium" onClick={actions.startEditing}>
      {t('action.editList')}
    </Button>
  )
}

export default EditButton
